export const strictEntries: <K extends string, T>(obj: Partial<{ [k in K]: T }>) => ReadonlyArray<[K, T]> =
  Object.entries;
